// extracted by mini-css-extract-plugin
module.exports = {"icon":"PinForm_icon__1VZ9_","mainText":"PinForm_mainText__kq1TW"};